import { Descriptions } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getPgSetting, updatePgSetting } from "../../api/campuses.api";
import Button from "../../components/Button";
import ErrorResponse from "../../components/ErrorResponse";
import SimpleHeader from "../../components/layout/SimpleHeader";
import Loader from "../../components/Loader";
import ConfirmModal from "../../components/modals/ConfirmModal";
import Radio from "../../components/Radio";
import SelectCampus from "../../components/SelectCampus";
import useAuth from "../../hooks/useAuth";
import useAxios from "../../hooks/useAxios";
import useNotification from "../../hooks/useNotification";
import { IGetPgSetting } from "../../models/campuses.model";
import { RootState } from "../../store/rootReducer";

const CampusPgSetting = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetPgSetting>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [onlineStoreKey, setOnlineStoreKey] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [posMid, setPosMid] = useState('');
  const [padUseYn, setPadUseYn] = useState('N');
  const [confirmSubmitVisible, setConfirmSubmitVisible] = useState(false);

  useEffect(() => {
    if (currentCampus) {
      execute(getPgSetting(currentCampus));
    }
  }, [currentCampus]);

  useEffect(() => {
    setOnlineStoreKey(res?.data?.onlineStoreKey || '');
    setSecretKey(res?.data?.secretKey || '');
    setPosMid(res?.data?.posMid || '');
    setPadUseYn(res?.data?.padUseYn || 'N');
  }, [res]);

  useEffect(() => {
    if (submitRes) {
      setConfirmSubmitVisible(false);
      successNotification(t('common.message.save1'));
    }
  }, [submitRes]);

  const onSubmit = async () => {
    const req = {
      onlineStoreKey,
      secretKey,
      posMid,
      padUseYn,
    }

    submitExecute(updatePgSetting(currentCampus, req));
  }

  return (
    <>
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-campus-big.png"
        parentMenu={t('common.menu.campus')}
        currentMenu={t('campus.pgSetting.title1')}
        onlyTitle={true}
      />

      <div className="comm-table__area rowType">
        <Descriptions
          bordered
          size="small"
          column={1}
          labelStyle={{ width: '25%' }}
        >
          <Descriptions.Item label={t('common.menu.campus')}>
            <div className="w-150p">
              <SelectCampus />
            </div>
          </Descriptions.Item>          
          <Descriptions.Item label="MID (POS)">
            <input
              type="text"
              className="form-control input-text"
              value={posMid}
              onChange={e => setPosMid(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('campus.pgSetting.column1')}>
            <input
              type="text"
              className="form-control input-text"
              value={onlineStoreKey}
              onChange={e => setOnlineStoreKey(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('campus.pgSetting.column2')}>
            <input
              type="text"
              className="form-control input-text"
              value={secretKey}
              onChange={e => setSecretKey(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('campus.pgSetting.column3')}>
            <div className="radio-wrapper">
              <Radio
                checked={padUseYn === 'Y'}
                onChange={() => setPadUseYn('Y')}
                text={t('common.option.yes')}
              />
              <Radio
                checked={padUseYn === 'N'}
                onChange={() => setPadUseYn('N')}
                text={t('common.option.no')}
              />
            </div>
          </Descriptions.Item>
        </Descriptions>

        <div className="comm-bx__space">
          <div className="comm-btn__area right">
            <Button
              onClick={() => setConfirmSubmitVisible(true)}
              className="btn-basic pink"
              text={t('common.button.save')}
              writeAuthYn={writeAuthYn}              
            />
          </div>
        </div>
      </div>

      <ConfirmModal
        visible={confirmSubmitVisible}
        setVisible={setConfirmSubmitVisible}
        onConfirm={onSubmit}
        titleText={t('campus.pgSetting.title2')}
        messageText={t('campus.setting.text7')}
        confirmText={t('common.button.save')}
        cancelText={t('common.button.cancel')}
      />
    </div>
    </>
  );
}

export default CampusPgSetting;
